import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { NgImageSliderComponent } from 'ng-image-slider';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  @ViewChild('nav',{static:true}) slider: NgImageSliderComponent;
  DisplayAll: Boolean;
  spin:boolean;
  imageObject:any=[];
  title='ITARIUM Technologies India Pvt. Ltd.| Home';
  constructor(private titleService: Title, private meta: Meta) { 
  }
  prevImageClick() {
    this.slider.prev();
}

nextImageClick() {
    this.slider.next();
}
  ngOnInit() {
    this.titleService.setTitle(this.title);
    this.meta.addTags([
      {name: 'keywords', content: 'BMC, BMC Softwares, BMC Tools, Itarium Technologies India Pvt. Ltd.,Mobility, ECOLT, IOT, IT Support' },
      {name: 'description', content: 'Simplify businesses by leveraging innovative IT solutions & services'},
      {name: 'robots', content: 'index, follow'}
    ]);
    // this.spin=true
    //window.scrollTo(0, 0);

    //  this.slider.infinite = true;
    //  this.slider.animationSpeed = 1.5;
    //   this.slider.autoSlide = 2;

    this.imageObject = [{
      image: '../../assets/img/brand/bizspark2.png',
      thumbImage: '../../assets/img/brand/bizspark2.png',
      }, 
      {
        image: '../../assets/img/brand/microsoft.png',
        thumbImage: '../../assets/img/brand/microsoft.png',
      },
      {
        image: '../../assets/img/brand/AWS1.png',
          thumbImage: '../../assets/img/brand/AWS1.png',
      },
      {
        image: '../../assets/img/brand/bmc1.png',
          thumbImage: '../../assets/img/brand/bmc1.png',
      },{
        image: '../../assets/img/brand/google.png',
          thumbImage: '../../assets/img/brand/google.png',
      },
      {
        image: '../../assets/img/brand/NASSCOM1.png',
          thumbImage: '../../assets/img/brand/NASSCOM1.png',
      },
      {
        image: '../../assets/img/brand/sonicwall1.png',
          thumbImage: '../../assets/img/brand/sonicwall1.png',
      },
    ];
  }
  scroll(){
    window.scrollTo(380,380)
  }
  // ngAfterViewInit(){
  //   this.spin=false;
  // }
}